import { render, staticRenderFns } from "./OtherVendorsModal.vue?vue&type=template&id=019bfa3a&"
import script from "./OtherVendorsModal.vue?vue&type=script&lang=js&"
export * from "./OtherVendorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports